// extracted by mini-css-extract-plugin
export default {"panel-with-collapsible-panel":"fXeolb","panel-with-collapsible-panel__panel-left":"yjqaVX","panel-with-collapsible-panel__panel-right":"PZkYhH"};